export { Icon, DecorativeIcon } from '@lambdacurry/component-library';
